import { Area, Country, LocationState } from '@/models/location/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: LocationState = {
  selectedCountry: null,
  selectedArea: null,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setSelectedCountry: (state, { payload }: PayloadAction<Country | null>) => {
      state.selectedCountry = payload;
    },
    setSelectedArea: (state, { payload }: PayloadAction<Area | null>) => {
      state.selectedArea = payload;
    },
    resetLocation: (state) => {
      state.selectedArea = null;
      state.selectedCountry = null;
    },
  },
});

export const { setSelectedCountry, setSelectedArea, resetLocation } =
  locationSlice.actions;
export const locationReducer = locationSlice.reducer;
